module.exports = __webpack_public_path__ + "media/images/ordi1-7afe251f6bcf10f31e3a77ac7b1ec687.png";